import { useState } from "react";
import { Checkbox } from "../ui/checkbox";
import { CaretRight, CaretDown, X } from "@phosphor-icons/react";

const ReqRow = ({ req, parts, onToggleReq, onTogglePart, notApplicable }) => {
  const [open, setOpen] = useState(false);
  const subs = req.sub_requirements || [];
  const checked = parts !== undefined;
  return (
    <div className="border-t border-border first:border-t-0" data-testid={`sop-req-row-${req.standard_id}-${req.req_number}`}>
      <div className="flex items-start gap-2 px-2 py-1.5">
        <Checkbox data-testid={`sop-req-check-${req.standard_id}-${req.req_number}`} checked={checked}
          onCheckedChange={() => onToggleReq(req.id)} className="mt-0.5 rounded-none" />
        <button type="button" onClick={() => subs.length && setOpen(!open)} className="flex-1 text-left text-xs leading-snug">
          <span className="font-mono font-semibold mr-1">{req.req_number}</span>
          <span className="text-muted-foreground line-clamp-2">{req.text}</span>
          {checked && parts.length > 0 && <span className="text-[10px] text-primary font-semibold"> Parts {parts.join(", ")} only</span>}
          {notApplicable && <span data-testid={`sop-req-na-${req.standard_id}-${req.req_number}`} className="ml-1 text-[10px] uppercase border border-slate-300 text-slate-500 px-1">Not your functions</span>}
        </button>
        {subs.length > 0 && (
          <button type="button" data-testid={`sop-req-expand-${req.standard_id}-${req.req_number}`} onClick={() => setOpen(!open)}
            className="text-muted-foreground hover:text-foreground mt-0.5" title="Pick individual parts">
            {open ? <CaretDown size={12} /> : <CaretRight size={12} />}
          </button>
        )}
      </div>
      {open && (
        <div className="pl-8 pr-2 pb-2 space-y-1">
          <div className="text-[10px] text-muted-foreground">Leave all parts unticked to cover the whole requirement.</div>
          {subs.map((s) => (
            <label key={s.label} className="flex items-start gap-2 text-[11px] cursor-pointer">
              <Checkbox data-testid={`sop-part-check-${req.standard_id}-${s.label}`} checked={(parts || []).includes(s.label)}
                onCheckedChange={() => onTogglePart(req.id, s.label)} className="mt-0.5 h-3.5 w-3.5 rounded-none" />
              <span><b className="font-mono">{s.label}</b> <span className="text-muted-foreground line-clamp-2">{s.text}</span></span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
};

export const StandardReqChecklist = ({ standardId, reqs, selection, onToggleReq, onTogglePart, onSetAll, onRemove, applicableIds = null }) => {
  const [open, setOpen] = useState(true);
  const count = reqs.filter((r) => selection[r.id] !== undefined).length;
  return (
    <div className="border border-border" data-testid={`sop-std-block-${standardId}`}>
      <div className="flex items-center gap-2 px-2 py-1.5 bg-secondary/40">
        <button type="button" onClick={() => setOpen(!open)} className="flex items-center gap-1 font-mono font-semibold text-xs flex-1 text-left">
          {open ? <CaretDown size={12} /> : <CaretRight size={12} />}{standardId}
          <span className="font-sans font-normal text-muted-foreground ml-1">{count}/{reqs.length} selected</span>
        </button>
        <button type="button" data-testid={`sop-std-all-${standardId}`} onClick={() => onSetAll(standardId, count < reqs.length)}
          className="text-[11px] underline text-muted-foreground hover:text-foreground">{count < reqs.length ? "All" : "None"}</button>
        <button type="button" data-testid={`sop-std-remove-${standardId}`} onClick={() => onRemove(standardId)} title="Remove standard"
          className="text-muted-foreground hover:text-red-700"><X size={12} /></button>
      </div>
      {open && (
        <div className="max-h-64 overflow-y-auto">
          {reqs.map((r) => <ReqRow key={r.id} req={r} parts={selection[r.id]} onToggleReq={onToggleReq} onTogglePart={onTogglePart}
            notApplicable={!!applicableIds && !applicableIds.has(r.id)} />)}
        </div>
      )}
    </div>
  );
};
